<template>
    <div>
        <container :aside="'police'">
            <div class="warp">
                <div class="head base-head">
                    <el-row>
                        <el-col :span="16" :offset="0">
                            <el-form :model="form" label-width="80px" :inline="true" size="mini">
                                <!-- <el-form-item label="辖区">
                                    <el-cascader
                                    v-model="form.classification"
                                    :options="securityArea"
                                    :props="props"
                                    collapse-tags
                                    clearable></el-cascader>
                                </el-form-item>
                                <el-form-item label="出租类型">
                                    <el-select v-model="form.rentway" value-key="" placeholder="请选择出租类型" clearable filterable>
                                        <el-option v-for="(item, key) in workinggroups"
                                            :key="key"
                                            :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="房源">
                                    <el-input v-model="form.housekeyword" placeholder="请输入房源名称/地址"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" @click="onsearch">筛选</el-button>
                                </el-form-item> -->
                                <el-form-item>
                                    <el-button type="success" icon="el-icon-folder-opened" @click="exportinfo">导出</el-button>
                                </el-form-item>
                            </el-form>
                            
                        </el-col>
                        <el-col :span="8" :offset="0">
                            <div class="search-box">
                                <el-input class="search-input" v-model="keyword" placeholder="请输入房东姓名/手机号/身份证搜索" size="small" clearable @input="onsearch"></el-input>
                                <span class="el-icon-search" @click="onsearch"></span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <div class="table-box">
                    <el-table :data="tabledata" border stripe size="mini" v-loading="loading">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column label="姓名" prop="name"></el-table-column>
                        <el-table-column label="手机" prop="telephone"></el-table-column>
                        <el-table-column label="身份证" prop="idcard"></el-table-column>
                        <!-- <el-table-column label="注册时间" prop="addDate"></el-table-column>
                        <el-table-column label="房源数量" prop="housecount"></el-table-column> -->
                        <el-table-column label="门店数量" prop="pinpai">
                            <template slot-scope="s">
                                <p class="text" v-if="s.row.houseRegions">{{s.row.houseRegions.length}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="240">
                            <template slot-scope="s">
                                <el-button-group>
                                    <el-button type="primary" size="mini" icon="el-icon-s-custom" @click="landlorddetail(s.row)">房东详情</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="out-table-box">
                    <el-table id="out-table" :data="outtabledata" border stripe size="mini" v-loading="loading">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column label="姓名" prop="name"></el-table-column>
                        <el-table-column label="手机" prop="telephone"></el-table-column>
                        <el-table-column label="身份证" prop="idcard"></el-table-column>
                        <!-- <el-table-column label="注册时间" prop="addDate"></el-table-column> -->
                        <!-- <el-table-column label="房源数量" prop="housecount"></el-table-column> -->
                        <el-table-column label="门店数量" prop="pinpai">
                            <template slot-scope="s">
                                <p class="text" v-if="s.row.houseRegions">{{s.row.houseRegions.length}}</p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :current-page="pageNo"
                    small
                    :total="total" background>
                </el-pagination>
                <router-view></router-view>
            </div>
        </container>
        
    </div>
</template>

<script>
import FileSaver from 'file-saver';
import XLSX from "xlsx";
import Container from '../../../components/container.vue'
export default {
    components: {
        Container,
    },
    data() {
        return {
            form: {
                rentway: '',
                housekeyword: '',
                classification: [],
            },
            securityArea: [],
            props: { multiple: true },
            workinggroups: ['长租', '网约房', '板房', '合租', '公租'],
            keyword: '',
            loading: false,
            tabledata: [],
            pagesize: 15,
            pageNo: 0,
            total: 0,
            outtabledata: [],
        }
    },
    mounted () {
        this.gettabledata();
        this.getSecurityArea();
    },
    methods: {
        exportinfo() {
            if (this.loading) return;
            this.loading = true;
            var that = this;
            var params = {
                pageNo: this.pageNo,
                pagesize: 999999999,
                region: this.form.region||'',
                rentway: this.form.rentway||'',
                keyword: this.keyword||'',
                housekeyword: this.form.housekeyword||'',
                classification: JSON.stringify(this.form.classification),
            }
            this.$api.getlandlordlistvssearch(params)
                .then(data=>{
                    this.loading = false;
                    let {list} = data;
                    this.outtabledata = list;
                    this.$nextTick(function(){
                        that.exportExcel();
                    })
                })
        },
        exportExcel () {
            var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
            let wb = XLSX.utils.table_to_book(
                document.querySelector("#out-table"),
                xlsxParam
            );
            let wbout = XLSX.write(wb, {
                bookType: "xlsx",
                bookSST: true,
                type: "array"
            });
            // 获取当前的时间戳，用来当文件名
            let time = new Date().getTime();
            try {
                FileSaver.saveAs(
                new Blob([wbout], { type: "application/octet-stream" }),
                `${time}.xlsx`
                ); //${time}是自己导出文件时的命名，随意
            } catch (e) {
                // if (typeof console !== "undefined") console.log(e, wbout);
            }
            return wbout;
        },
        getSecurityArea() {
            this.$api.getSecurityArea({})
                .then(data=>{

                    let {securityArea} = data;
                    this.securityArea = securityArea;
                })
        },
        onsearch() {
            this.pageNo = 0;
            this.gettabledata();
        },
        landlorddetail(item) {
            var id = this.$Base64.encode(item._id);
            this.$router.push({path: '/police/landlord/detail', query: {uid: id, type: 'landlord'}})
        },
        gettabledata() {
            this.loading = true;
            var params = {
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                rentway: this.form.rentway||'',
                keyword: this.keyword||'',
                housekeyword: this.form.housekeyword||'',
                classification: JSON.stringify(this.form.classification),
            }
            this.$api.getLandlordList(params)
                .then(data=>{
                    this.loading = false;
                    var {list, total} = data;
                    this.tabledata= list;
                    this.total = total;
                })
        },
        currentChange(page) {
            this.pageNo = page-1;
            this.gettabledata();
        },
    },
}
</script>

<style lang="scss" scoped>
.search-input{
    /deep/.el-input__inner{
        border: none;
    }
}
.out-table-box{
    position: absolute;
    bottom: -99999999px;
}
</style>